import { getImage } from 'astro:assets'

export function capitalize(str) {
    return str.split('_').map(word => word[0].toUpperCase() + word.substring(1)).join(' ');
}

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function snakeCase(str, delim = '-') {
    str = str.trim();
    str = str.replace(/[\s.]+/g, delim);
    str = str.toLowerCase();
    return str;
}

export function truncate(str, num = 100, ellipses = '...') {
    if (str.length <= num) {
        return str
    }
    return str.slice(0, num) + ellipses
}

export function formatNumber(num, decimals = 0) {
    return Number(num).toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function formatPrice(price) {
    return formatNumber(price, 2).replace('.00', '')
}

export function startWith(str, start) {
    return str?.startsWith(start) ? str : start + str
}

export function endWith(str, end) {
    return str?.endsWith(end) ? str : str + end
}

export function relativeUrl(url) {
    return endWith((new URL(url)).pathname, '/')
}

export function groupBy(xs, cb) {
    return xs.reduce(function(rv, x) {
        (rv[cb(x)] = rv[cb(x)] || []).push(x);
        return rv;
    }, {});
}

export function chunk(array, chunkSize = 4) {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
}

export function topOccurrences(arr, count) {
    const frequencyMap = new Map();

    for (const element of arr) {
        frequencyMap.set(element, (frequencyMap.get(element) || 0) + 1);
    }
    const sortedEntries = [...frequencyMap.entries()].sort((a, b) => b[1] - a[1]);
    return sortedEntries.slice(0, count).map(([element]) => element);
}

export function decodeJwt(token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''))

    return JSON.parse(jsonPayload)
}

export function isObjectEmpty(objectName) {
    return Object.keys(objectName).length === 0
}

const commonScreenWidths = [360, 390, 414, 768, 1366, 1920]

export function getSrcSet(image, maxWidth = null) {
    let noQueryUrl = image.url.split('?')[0].replace('cdn.', 'img.')
    let minWidth = !!maxWidth ? Math.min(image.width, maxWidth) : image.width

    return noQueryUrl.includes('https://img.hometownhero.com')
        ? [...commonScreenWidths, minWidth]
            .filter(width => width <= minWidth)
            .map(width => `${noQueryUrl}?tr=w-${width} ${width}w`)
            .join(', ')
        : null
}

export async function getCollectionPictureSources(collection) {
    let collectionImages = []
    let reversedScreenWidths = [...commonScreenWidths].reverse()
    if (collection?.image) {
        for (const [i, width] of reversedScreenWidths.entries()) {
            let imgWidth = reversedScreenWidths[i - 1] || width
            let image = collection?.mobile_image && width < 768
                ? collection.mobile_image
                : collection.image

            collectionImages[width + 1] = await getImage({
                src: image.url.replace('img.', 'cdn.'),
                width: imgWidth,
                height: Math.round(imgWidth / image.aspect_ratio),
                densities: [1, 2, 3],
                quality: 90,
            })
        }
    }
    return collectionImages
}

export { commonScreenWidths }

export async function generateRecaptchaToken(action) {
    return new Promise((resolve) => {
        grecaptcha.ready(
            () =>
                void (async () => {
                    const token = await grecaptcha.execute(
                        import.meta.env.PUBLIC_RECAPTCHA_SITE_KEY,
                        {action},
                    );

                    resolve(token);
                })(),
        );
    })
}
